/**
 * Sprint 19 micro-polish — display-only "Connected since HH:MM" formatter.
 * Stable, locale-aware 24h-style hour:minute. No relative ticking.
 * Returns null when input is falsy or invalid so callers can safely render
 * with `{label && <span>…</span>}`.
 */
export function formatConnectedSince(date) {
  if (!date) return null;
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return null;
  return `Connected since ${d.toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  })}`;
}
